(ns iris.websocket.auth
  (:require [re-frame.core :as rf]
            [day8.re-frame.http-fx]
            [ajax.core :as ajax]
            [iris.globals :as globals]
            [iris.config :as config]))

(rf/reg-event-fx
 :iris.websocket.auth/get-token
 (fn [{:keys [db]} _]
   (js/console.log "Auth: getting token...")
   (let [fp (:fp db)
         ;; Get Iris JWT if user is logged in
        ;;  iris-jwt (js/localStorage.getItem "jwt")
        iris-jwt @globals/jwt
         ]
     (js/console.log "Auth: fingerprint" fp "has jwt?" (boolean iris-jwt))
     (if fp
       {:http-xhrio {:method          :post
                     :uri             (str config/SOKRATES_HTTP_URL "/auth")
                     :params          (if iris-jwt
                                        ;; Authenticated: send both fingerprint and JWT
                                        {:fingerprint fp
                                         :external_jwt iris-jwt}
                                        ;; Anonymous: send only fingerprint
                                        {:fingerprint fp})
                     :format          (ajax/json-request-format)
                     :response-format (ajax/json-response-format {:keywords? true})
                     :on-success      [:iris.websocket.auth/token-received]
                     :on-failure      [:iris.websocket.auth/token-failed]}}
       (do
         (js/console.log "Auth: no fingerprint yet, retrying...")
         {:dispatch-later [{:ms 100 :dispatch [:iris.websocket.auth/get-token]}]})))))

(rf/reg-event-fx
 :iris.websocket.auth/token-received
 (fn [{:keys [db]} [_ response]]
   (js/console.log "Auth: token received!" response)
   {:db (-> db
            (assoc-in [:websocket :token] (:token response))
            (assoc-in [:websocket :authenticated] (:authenticated response)))
    :dispatch [:iris.websocket/connect-with-token (:token response)]}))

(rf/reg-event-fx
 :iris.websocket.auth/token-failed
 (fn [{:keys [db]} [_ error]]
   (js/console.error "Auth: failed to get token" error)
   {:db (assoc-in db [:websocket :error] error)
    :dispatch-later [{:ms 5000 :dispatch [:iris.websocket.auth/get-token]}]}))